import { ReactNode } from 'react';
import Checkbox from '@/storybook/components/FormCollection/Checkbox/Checkbox';

interface CheckboxFilterAdapterProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label: string;
  icon?: ReactNode;
}

export default function CheckboxFilterAdapter({ value, onChange, disabled, label, icon }: CheckboxFilterAdapterProps) {
  return (
    <Checkbox
      checked={!!value}
      onChange={e => onChange(e.target.checked)}
      disabled={disabled}
      label={label}
      icon={icon}
    />
  );
}
